export default __webpack_public_path__ + "static/media/laval5.0a54ac19.jpg";